import { render, staticRenderFns } from "./unionRatio.vue?vue&type=template&id=842159ec&scoped=true&"
import script from "./unionRatio.vue?vue&type=script&lang=js&"
export * from "./unionRatio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842159ec",
  null
  
)

export default component.exports